import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section className="py-12 px-4 max-w-5xl mx-auto pt-[5px] pb-[5px]" data-id="element-211">
      <div className="text-center mb-12" data-id="element-212">
        <h2 className="text-4xl md:text-5xl font-bold mb-4 font-serif" data-id="element-213">
          ELEGÍ TU MEGAPACK
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch" data-id="element-214">
        {/* Basic Pack */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 shadow-warm border border-cream-dark flex flex-col" data-id="element-215">
          <div className="mb-6" data-id="element-216">
            <h3 className="text-2xl font-bold text-carbon mb-2 flex items-center gap-2" data-id="element-217">
              📘 MEGAPACK COCINA
            </h3>
            <p className="text-brand-green font-medium mb-4" data-id="element-218">
              6 Tomos + 3 Bonos
            </p>
            <p className="text-sm text-carbon-lighter min-h-[40px]" data-id="element-219">
              Ideal para: Familias y emprendedores que quieren cocinar rico y
              vender desde casa
            </p>
          </div>

          <div className="mt-auto mb-8" data-id="element-220">
            <div className="text-carbon-lighter line-through text-xl mb-1" data-id="element-221">
              $45.000
            </div>
            <div className="text-4xl md:text-5xl font-bold text-carbon font-serif" data-id="element-222">
              $19.990{' '}
              <span className="text-xl font-sans text-carbon-lighter" data-id="element-223">ARS</span>
            </div>
          </div>

          <CTAButton fullWidth className="py-4" href="https://www.digitalbibliotec.online/cart/52075964367130:1" data-id="element-224">
            → QUIERO MI MEGAPACK AHORA
          </CTAButton>
        </motion.div>

        {/* Premium Pack */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="bg-carbon rounded-3xl p-8 shadow-warm-lg border-2 border-brand-green flex flex-col relative transform md:-translate-y-4" data-id="element-225">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-green text-white px-4 py-1 rounded-full text-sm font-bold tracking-wide whitespace-nowrap" data-id="element-226">
            MÁS ELEGIDO
          </div>

          <div className="mb-6" data-id="element-227">
            <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-228">
              🏆 MEGAPACK + MARCA GOURMET ⭐
            </h3>
            <p className="text-brand-green font-medium mb-4" data-id="element-229">
              6 Tomos + 3 Bonos + Kit de Profesionalización Completo
            </p>
            <p className="text-sm text-cream-dark min-h-[40px]" data-id="element-230">
              Ideal para: Emprendedores que quieren construir una marca
              reconocida en su barrio
            </p>
          </div>

          <div className="mt-auto mb-8" data-id="element-231">
            <div className="text-carbon-lighter line-through text-xl mb-1" data-id="element-232">
              $65.000
            </div>
            <div className="text-4xl md:text-5xl font-bold text-white font-serif" data-id="element-233">
              $27.990{' '}
              <span className="text-xl font-sans text-cream-dark" data-id="element-234">ARS</span>
            </div>
          </div>

          <CTAButton fullWidth className="py-4 bg-brand-green hover:bg-brand-greenHover shadow-lg shadow-brand-green/20" href="https://www.digitalbibliotec.online/cart/52075975344410:1" data-id="element-235">
            → QUIERO EL MEGAPACK + MARCA GOURMET
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}